import React from 'react';
import styles from './styles.module.scss';
import { Image } from 'semantic-ui-react';

const ArrowLoader = ({ arrowStyles }) => (
    <div className={styles.cycleArrowLoader} style={{ ...arrowStyles }}>
        <Image src={require('../../assets/img/cycle-arrow.svg')} />
    </div>
);

export default ArrowLoader;
